import { render, staticRenderFns } from "./S2.vue?vue&type=template&id=be39ff4a&scoped=true&"
import script from "./S2.vue?vue&type=script&lang=js&"
export * from "./S2.vue?vue&type=script&lang=js&"
import style0 from "./S2.vue?vue&type=style&index=0&id=be39ff4a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be39ff4a",
  null
  
)

export default component.exports